import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/Services/api.service';
import { Observable, BehaviorSubject } from 'rxjs';
import { UserData } from 'src/app/Services/data.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SuperAdminApiService {
  odPayDomain: string = environment.odPayDomain;
  public logoUpdated = new BehaviorSubject<string>(localStorage.getItem('displayLogo'));

  browserDomain : string = this.service.browserDomain;
  constructor(private http: HttpClient, private service: ApiService) { }


  URLAddress(address){
    const FinalURL = this.service.URLAddress(address,'superAdmin')
    return FinalURL; 
  }
  
  ///////Other Module API......

  getCourseList(entityId, session): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/course?entity=' +entityId+'&session='+session))
  }
  getCourseData(entityId): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/course?id='+entityId) );
  }



  // Entity Data
  getEntityList(): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/entity'))
  }
  getBillingEntityList(paymentDueAlert): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/entity?paymentDueAlert='+paymentDueAlert))
  }
  
  addEntityData(entityData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/add/entity"), entityData);
  }

  createODPayEntity(data): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/createODPayEntity/entity'),data );
  }

  getDistinctBranchIds(entityId): Observable<any>{
    return this.http.get<any>(this.URLAddress('/getDistinctBranchIds/course?entity=' + entityId));
  }

  getOdPayEntities(payload): Observable<any>{
    return this.http.post<any>(this.URLAddress('/getOdPayEntities/odpay'), payload);
  }
  getEntityData(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/entity?id='+id) );
  }
  editEntityData(entityData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/edit/entity"), entityData);
  }

  uploadEntityLogo(entityId, qac, fileData):Observable<any>{
    return this.http.post<any>(this.URLAddress("/uploadEntityLogo?id="+ entityId+ '&qac='+qac),fileData );
  }
  uploadEntityStaticQr(id, qac, fileData):Observable<any>{
    return this.http.post<any>(this.URLAddress("/uploadEntityStaticQR?qac="+ qac+ '&id='+id),fileData );
  }
  refreshUserTokens(id): Observable<any>{
    return this.http.get<any>(this.URLAddress('/refreshUserTokens/user?entity='+id) );
  }
  // Admin Data
  getAdminData(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/getAdmin/user?entity='+id) );
  }
  editAdminData(adminData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/editAdmin/user"), adminData);
  }
  addAdminData(adminData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/addAdmin/user"), adminData);
  }
  listWhiteLabelling(): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/whiteLabelling'))
  }
  addWhiteLabelling(adminData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/add/whiteLabelling"), adminData);
  }
  viewWhiteLabelling(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/whiteLabelling?id='+id) );
  }
  editWhiteLabelling(adminData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/edit/whiteLabelling"), adminData);
  }
  uploadWhiteLabelling(name, fileData):Observable<any>{
    return this.http.post<any>(this.URLAddress("/uploadWhiteLabelling?qac="+ name),fileData );
  }
  getWhiteLabellingByURL(url): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/getWhiteLabellingByURL?url='+url) );
  }
  sendMIS(): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/sendMIS/entity'))
  }
  sendSingleMIS(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/sendMIS/entity?entityId='+id))
  }
  sendMonthlyMIS(): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/sendMonthlyMIS/entity'))
  }
  sendWeeklyMIS(): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/sendWeeklyMIS/entity'))
  }
  sendWhatsappWebMIS(): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/sendMIS/entity?onlyWhatsAppWeb='+true))
  }

  saveMetaData(id,model,data):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/saveMetadata?id='+id+'&model='+model), data)
  }

  //faq
  listfaq():Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/faq'))
  }
  addFaq(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/add/faq'),formData)
  }
  editFaq(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/faq'),formData)
  }
  viewfaq(id):Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/faq?id='+id))
  }
  deleteFaq(id):Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/delete/faq?id='+id))
  }

  // Cron Jobs
  listCron(startDate,endDate):Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/cron?startDate='+startDate+'&endDate='+endDate));
  }
  viewCron(id):Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/cron?cronId='+id))
  }

  //userAnalytics
  getUserAnalytics(formData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/usageAnalytics/superDashboard'),formData);
  }

  listAllDefaultPdfTemplate():Observable<any[]>{
    return this.http.get<any[]>(this.URLAddress('/list/defaultPDFTemplate'))
  }
  addDefaultPdfTemplate(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/add/defaultPDFTemplate'),formData)
  }
  editDefaultPdfTemplate(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/edit/defaultPDFTemplate'),formData)
  }
  viewDefaultPDFTemplate(id):Observable<any>{
    return this.http.get<any>(this.URLAddress('/view/defaultPDFTemplate?id='+id))
  }
  deleteDefaultPDFTemplate(id):Observable<any>{
    return this.http.get<any>(this.URLAddress('/delete/defaultPDFTemplate?id='+id))
  }
  listDefaultPdfTemplate(report,entityType):Observable<any[]>{
    let queryParams = report;
    if(entityType)
    {
      queryParams +='&entityType='+entityType
    }
    return this.http.get<any[]>(this.URLAddress('/list/defaultPDFTemplate?report='+queryParams));
  }
  resetUserPassword(id, password): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/resetPassword/user?id='+id+'&password='+password))
  }
  listDefaultExcelTemplateAll(): Observable<UserData[]>{
    // let queryParams
    // if(report)
    // {
    //   queryParams+='&report='+report
    // }
    return this.http.get<UserData[]>(this.URLAddress('/list/defaultExcelTemplate') );
  }
  listDefaultExcelTemplateFilter(report): Observable<UserData[]>{
    // let queryParams
    // if(report)
    // {
    //   queryParams+='&report='+report
    // }
    return this.http.get<UserData[]>(this.URLAddress('/list/defaultExcelTemplate?report='+report));
  }
  viewDefaultExcelTemplate(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/defaultExcelTemplate?id='+id) );
  }
  deleteDefaultExcelTemplate(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/delete/defaultExcelTemplate?id='+id) );
  }
  addDefaultExcelTemplate(formData):Observable<any>{
    return this.http.post<any>((this.URLAddress('/add/defaultExcelTemplate')),formData)
  }
  editDefaultExcelTemplate(formData):Observable<any>{
    return this.http.post<any>((this.URLAddress('/edit/defaultExcelTemplate')),formData)
  }

  listAllDefaultCommunicationTemplate():Observable<any[]>{
    return this.http.get<any[]>(this.URLAddress('/list/defaultCommunicationTemplate'))
  }
  addDefaultCommunicationTemplate(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/add/defaultCommunicationTemplate'),formData)
  }
  editDefaultCommunicationTemplate(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/edit/defaultCommunicationTemplate'), formData)
  }
  viewDefaultCommunicationTemplate(id):Observable<any>{
    return this.http.get<any>(this.URLAddress('/view/defaultCommunicationTemplate?id='+id))
  }
  deleteDefaultCommunicationTemplate(id):Observable<any>{
    return this.http.get<any>(this.URLAddress('/delete/defaultCommunicationTemplate?id='+id))
  }


  listAllDefaultAttachmentTemplate():Observable<any[]>{
    return this.http.get<any[]>(this.URLAddress('/list/defaultAttachmentTemplate'))
  }
  addDefaultAttachmentTemplate(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/add/defaultAttachmentTemplate'),formData)
  }
  editDefaultAttachmentTemplate(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/edit/defaultAttachmentTemplate'), formData)
  }
  viewDefaultAttachmentTemplate(id):Observable<any>{
    return this.http.get<any>(this.URLAddress('/view/defaultAttachmentTemplate?id='+id))
  }
  deleteDefaultAttachmentTemplate(id):Observable<any>{
    return this.http.get<any>(this.URLAddress('/delete/defaultAttachmentTemplate?id='+id))
  }
  viewDefaultMarkedAttachmentTemplate(report,entityType)
  {
        let queryParams = report;
    if(entityType)
    {
      queryParams +='&entityType='+entityType
    }
    return this.http.get<any[]>(this.URLAddress('/viewDefault/defaultAttachmentTemplate?report='+queryParams));
  }

  getPresignedUrl(qac,formData):Observable<any>{
    return this.http.post<any>(this.URLAddress("/getPresignedUrl?qac="+ qac),formData);
  }
  listDeleteEntityRequest():Observable<any[]>{
    return this.http.get<any[]>(this.URLAddress('/list/deleteEntityRequest'))
  }
  addDeleteEntityRequest(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/add/deleteEntityRequest'),formData)
  }
  sendOtp1(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/sendOtp1/deleteEntityRequest'),formData)
  }
  verifyOtp1(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/verifyOtp1/deleteEntityRequest'),formData)
  }
  sendOtp2(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/sendOtp2/deleteEntityRequest'),formData)
  }
  verifyOtp2(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/verifyOtp2/deleteEntityRequest'),formData)
  }


  listUsers(entityId, session): Observable<UserData[]> {
    return this.http.get<UserData[]>(this.URLAddress('/list/user?entity=' + entityId + '&session=' + session));
  }
}
